import { render, staticRenderFns } from "./InformationSource.vue?vue&type=template&id=46388f22"
import script from "./InformationSource.vue?vue&type=script&lang=js"
export * from "./InformationSource.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports